<template>
    <div>
        <gantt-menu>
        </gantt-menu>
        <div style="height:500px;" ref="gantt">

        </div>
        <div class="card">
            <div class="card-body">
                <div class="table-responsive">
                    <table class="table table-striped">
                        <thead>
                        <tr>
                            <th>{{trans('tasks.fields.name')}}</th>
                            <th>{{trans('tasks.fields.owner_name')}}</th>
                            <th>{{trans('tasks.fields.visi_group_name')}}</th>
                            <th>{{trans('tasks.fields.eh')}}</th>
                            <th>{{trans('tasks.fields.start_date')}}</th>
                            <th>{{trans('tasks.fields.deadline')}}</th>
                            <th>{{trans('general.actions')}}</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr v-for="task in source_tasks">
                            <td>{{task.name}}</td>
                            <td v-html="renderOwner(task)"></td>
                            <td v-html="randerOwnerVisiGroup(task)"></td>
                            <td v-html="renderEstimatedHours(task)"></td>
                            <td v-html="renderStartDate(task)"></td>
                            <td v-html="renderDeadline(task)"></td>
                            <td>
                                <button @click="addSourceTask(task)" class="btn btn-primary">
                                    <span class="fa fa-plus-circle"></span>
                                </button>
                            </td>
                        </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {Message} from 'element-ui';

    import 'dhtmlx-gantt';
    import 'dhtmlx-gantt/codebase/ext/dhtmlxgantt_marker';
    import 'dhtmlx-gantt/codebase/ext/dhtmlxgantt_undo';
    import 'dhtmlx-gantt/codebase/ext/dhtmlxgantt_fullscreen';
    import 'dhtmlx-gantt/codebase/ext/dhtmlxgantt_smart_rendering';

    require('./ext/nav_menu');
    require('./ext/zoom');
    require('./ext/zoom_to_fit');
    require('./ext/auto_task_type');
    require('./ext/wbs_calc');
    require('./ext/drag_row_simple');
    require('./ext/grid_struct');
    require('./ext/fit_task_text');
    require('./ext/api');
    // require('./ext/auto_schedulling');

    let moment = require('moment');

    export default {
        name: "gantt",
        props: {
            project: Object,
            startDate: String,
        },
        data() {
            return {
                source_tasks: [],
                apiUrl: laroute.route('json.project.gantt', {project: this.project.id})
            }
        },
        mounted: function () {

            this.loadSourceTasks();

            gantt.config.duration_unit = "hour";
            gantt.config.order_branch = true;
            gantt.config.order_branch_free = true;
            gantt.config.undo = true;
            gantt.config.redo = true;
            gantt.config.grid_resize = true;

            var date_to_str = gantt.date.date_to_str(gantt.config.task_date);
            var today = moment();
            gantt.addMarker({
                start_date: today.toDate(),
                css: "today",
                text: "Today",
                title: "Today: " + date_to_str(today.toDate())
            });

            gantt.config.start_date = moment(this.startDate, 'YYYY-MM-DD').toDate();

            gantt.config.xml_date = "%Y-%m-%d %H:%i:%s";

            gantt.config.grid_width = 500;

            gantt.config.work_time = true;  // removes non-working time from calculations
            gantt.config.skip_off_time = true;    // hides non-working time in the chart

            gantt.setWorkTime({hours: [9, 17]});

            // gantt.config.row_height = 23;
            gantt.config.order_branch = true;
            gantt.config.order_branch_free = true;

            gantt.config.static_background = true;
            gantt.config.auto_scheduling_strict = true;
            // ganttModules.zoom.setZoom(4);
            ganttModules.menu.setup();

            gantt.locale.labels.section_owner = "Owner";
            gantt.locale.labels.section_note = "Note";
            gantt.config.lightbox.sections = [
                {name: "description", height: 30, map_to: "text", type: "textarea", focus: true},
                {
                    name: "owner", map_to: "owner_id", type: "select",
                    height: 35,
                    options: gantt.serverList("owners"),
                    template: function (item) {
                        return vm.ownerById(gantt.serverList('owners'), item.owner_id)
                    }
                },
                {name: "note", height: 45, map_to: "note", type: "textarea"},
                {name: "time", type: "duration", map_to: "auto"}
            ];
            gantt.templates.rightside_text = function (start, end, task) {
                return vm.ownerById(gantt.serverList('owners'), task.owner_id);
            };
            gantt.templates.leftside_text = function (start, end, task) {
                return task.note;
            };

            gantt.templates.grid_row_class =
                gantt.templates.task_row_class =
                    gantt.templates.task_class = function (start, end, task) {
                        var css = [];
                        if (task.$virtual || task.type == gantt.config.types.project)
                            css.push("summary-bar");

                        if (task.owner_id) {
                            css.push("gantt_resource_task gantt_resource_" + task.owner_id);
                        }

                        return css.join(" ");
                    };

            gantt.ignore_time = function (date) {
                if (date.getHours() < 9 || date.getHours() > 17) {
                    return true;
                }

                return false;
            };

            gantt.config.columns = [
                {
                    name: "owner", width: 100, align: "center",
                    label: "Owner",
                    template: function (item) {
                        return vm.ownerById(gantt.serverList('owners'), item.owner_id)
                    }
                },
                {name: "text", label: "Task name", tree: true, width: '*'},
                {name: "start_date", align: "center", "width": 90},
                {name: "duration", align: "center", width: 70},
                {name: "add", width: 40, align: 'right'}
            ];

            gantt.templates.scale_cell_class = function (date) {
                if (date.getDay() == 0 || date.getDay() == 6) {
                    return "week_end";
                }
                // if (!gantt.isWorkTime(date, 'hour')) {
                //     return "week_end";
                // }
            };

            gantt.templates.task_cell_class = function (item, date) {
                if (date.getDay() == 0 || date.getDay() == 6) {
                    return "week_end"
                }
                // if (!gantt.isWorkTime(date, 'hour')) {
                //     return "week_end";
                // }
            };

            // this.initialEventsHandlers();
            let vm = this;

            Vue.nextTick(() => {
                gantt.init(this.$refs.gantt);
                gantt.load(vm.apiUrl);

                let dp = new gantt.dataProcessor(vm.apiUrl);
                dp.init(gantt);
                let token = document.head.querySelector('meta[name="csrf-token"]');

                dp.setTransactionMode({
                    mode: "REST",
                    headers: {
                        'X-CSRF-TOKEN': token.content,
                        'Content-Type': 'application/json'
                    }
                });

            });

            gantt.attachEvent("onLoadEnd", function () {
                // use an arbitrary id for the style element
                var styleId = "dynamicGanttStyles";

                // in case you'll be reloading options with colors - reuse previously
                // created style element

                var element = document.getElementById(styleId);
                if (!element) {
                    element = document.createElement("style");
                    element.id = styleId;
                    document.querySelector("head").appendChild(element);
                }
                var html = [];
                var resources = gantt.serverList("owners");

                // generate css styles for each option and write css into the style element,

                resources.forEach(function (r) {
                    html.push(".gantt_row.gantt_resource_" + r.key + " .gantt_cell:first-of-type .gantt_tree_content {" +
                        "background-color:" + r.backgroundColor + "; " +
                        "color:#fff;" +
                        "}");
                });
                element.innerHTML = html.join("");

            });

            gantt.attachEvent("onTaskCreated", function (task) {
                if (!task.owner_id) {
                    task.duration = 8;
                }

                return true;
            });
        },
        methods: {
            trans(path) {
                return Lang.get(path);
            },
            loadSourceTasks() {
                let vm = this;
                axios.get(laroute.route('json.project.tasks', {project: this.project.id}))
                    .then(response => {
                        vm.source_tasks = response.data;
                    })
                    .catch(e => {
                        Message.error('Error trying load source tasks.');
                        console.log(e);

                    })
            },
            addSourceTask(task) {
                gantt.createTask({
                    text: task.name,
                    start_date: moment(task.start_date).toDate(),
                    duration: task.estimated_hours,
                    owner_id: task.owner_id
                });
            },
            renderEstimatedHours(task) {
                return DataTableTasks.renderEstimatedHours(task);
            },
            randerOwnerVisiGroup(task) {
                return DataTableTasks.renderOwnerVisiGroupName(task);
            },
            renderOwner(task) {
                return DataTableTasks.renderOwnerFullName(task);
            },
            renderStartDate(task) {
                return DataTableTasks.renderStartDate(task);
            },
            renderDeadline(task) {
                return DataTableTasks.renderDeadline(task);
            },
            getOwner(ownerId) {
                return this.ownerById(gantt.serverList('owners'), ownerId).full_name;
            },
            ownerById(list, id) {
                for (var i = 0; i < list.length; i++) {
                    if (list[i].id === parseInt(id))
                        return list[i].full_name || "";
                }
                return "";
            },
            serverProcessUpdate(task) {

                axios.post(laroute.route('json.project.gantt.update', {
                    project: this.project.id,
                    task: task.id,
                }), task)
                    .then(response => {
                        console.log(response.data);
                    })
                    .catch(e => {
                        console.log(e);
                    })
            },
            serverProcessCreate(task) {
                let oldId = task.id;
                axios.post(laroute.route('json.project.gantt.store', {
                    project: this.project.id,
                }), task)
                    .then(response => {
                        console.log(response.data);
                        gantt.getTask(oldId).id = response.data.tid;
                        gantt.updateTask(oldId);
                        gantt.refreshData();
                    })
                    .catch(e => {
                        console.log(e);
                    })
            },
            serverProcessDelete(id) {
                axios.post(laroute.route('json.project.gantt.remove', {
                    project: this.project.id,
                    task: id,
                }))
                    .then(response => {
                        console.log(response.data);
                    })
                    .catch(e => {
                        console.log(e);
                    })
            },
            // initialEventsHandlers() {
            //     let vm = this;
            //     gantt.attachEvent('onTaskSelected', (id) => {
            //         let task = gantt.getTask(id);
            //         this.$emit('task-selected', task)
            //     });
            //
            //     gantt.attachEvent('onAfterTaskAdd', (id, task) => {
            //         this.$emit('task-updated', id, 'inserted', task);
            //         task.progress = task.progress || 0;
            //
            //         vm.serverProcessCreate(task);
            //
            //         if (gantt.getSelectedId() == id) {
            //             this.$emit('task-selected', task)
            //         }
            //     });
            //
            //     gantt.attachEvent('onAfterTaskUpdate', (id, task) => {
            //         this.$emit('task-updated', id, 'updated', task);
            //         vm.serverProcessUpdate(task);
            //     });
            //
            //     gantt.attachEvent('onAfterTaskDelete', (id) => {
            //         this.$emit('task-deleted', id, 'deleted');
            //         if (!gantt.getSelectedId()) {
            //             this.$emit('task-selected', null)
            //         }
            //         vm.serverProcessDelete(id);
            //
            //     });
            //
            //     gantt.attachEvent('onAfterLinkAdd', (id, link) => {
            //         this.$emit('link-updated', id, 'inserted', link)
            //     });
            //
            //     gantt.attachEvent('onAfterLinkUpdate', (id, link) => {
            //         this.$emit('link-updated', id, 'updated', link)
            //     });
            //
            //     gantt.attachEvent('onAfterLinkDelete', (id, link) => {
            //         this.$emit('link-updated', id, 'deleted')
            //     });
            // }
        }
    }
</script>

<style scoped>
    @import "~dhtmlx-gantt/codebase/dhtmlxgantt.css";
</style>


// WEBPACK FOOTER //
// resources/assets/js/components/gantt/Gantt.vue